import { servicesStackedScroll } from '../../plugins/gsap/services-stacked-scroll';

servicesStackedScroll('.pane--quicklinks .quicklinks', '(min-width: 768px)');
